export default function Stat_Percentiles() {
  return <div>Stat_Percentiles Component</div>;
}
